// Shared v3 landing nav. Extracted from LandingV2 so it can be reused across
// v3-styled pages (Podcast, etc.). Anchor targets default to the landing page
// sections; pass `home` to point them at "/#section" when used off the landing.
import { Link } from 'react-router-dom'
import styles from './index.module.scss'
import { MCP_CLI_URL, CONTACT_URL } from '@/consts/Links.ts'
import wordmark from '@/assets/image/header/logo.png'

const LINKS = [
  { href: '#primitive', label: 'Product' },
  { href: '#problem', label: 'How it works' },
  { href: '#developers', label: 'Developers' },
  { href: '#security', label: 'Security' },
  { href: '#resources', label: 'Resources' },
]

const Nav = ({ home = false }) => (
  <nav className={styles.nav}>
    <Link to="/" className={styles.navBrand} aria-label="Vishwa home">
      <img src={wordmark} alt="Vishwa" />
    </Link>
    <div className={styles.navLinks}>
      {LINKS.map((l) => (
        <a key={l.href} href={home ? `/${l.href}` : l.href}>{l.label}</a>
      ))}
    </div>
    <div className={styles.navActions}>
      <a className={styles.navSignIn} href={MCP_CLI_URL} target="_blank" rel="noreferrer">Sign in</a>
      <a className={styles.navCta} href={CONTACT_URL} target="_blank" rel="noreferrer">Talk to us</a>
    </div>
  </nav>
)

export default Nav
